import posthog from "posthog-js";

const COOKIE_CONSENT_KEY = "cookie_consent_given";
let posthogLoaded = false;

function loadPosthogTracker(): void {
  if (posthogLoaded) {
    return;
  }

  posthog.init("phc_L0OAj5fEoEQydoH5YjXbpvuFJvWafJEJXPNSgWinQp3", {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
  });
}

function showBanner(): void {
  const banner = document.getElementById("cookie-consent-banner");
  if (banner) {
    banner.classList.remove("hidden");
  }
}

function hideBanner(): void {
  const banner = document.getElementById("cookie-consent-banner");
  if (banner) {
    banner.classList.add("hidden");
  }
}

function acceptCookies(): void {
  localStorage.setItem(COOKIE_CONSENT_KEY, "true");
  hideBanner();
  if (!posthogLoaded) {
    loadPosthogTracker();
  }
  window.dispatchEvent(
    new CustomEvent("cookieConsentChanged", { detail: { consentGiven: true } }),
  );
}

function declineCookies(): void {
  localStorage.setItem(COOKIE_CONSENT_KEY, "false");
  hideBanner();
  window.dispatchEvent(
    new CustomEvent("cookieConsentChanged", {
      detail: { consentGiven: false },
    }),
  );
}

export function initializeCookieConsent(): void {
  const consentGiven = localStorage.getItem(COOKIE_CONSENT_KEY);

  if (consentGiven === null) {
    // No choice made yet
    showBanner();
  } else if (consentGiven === "true") {
    if (!posthogLoaded) {
      loadPosthogTracker();
    }
  }

  const acceptButton = document.getElementById("cookie-consent-accept");
  const declineButton = document.getElementById("cookie-consent-decline");

  if (acceptButton) {
    acceptButton.addEventListener("click", acceptCookies);
  }
  if (declineButton) {
    declineButton.addEventListener("click", declineCookies);
  }
}

export function hasGivenCookieConsent(): boolean {
  return localStorage.getItem(COOKIE_CONSENT_KEY) === "true";
}

// Initialize on script load, typically after DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initializeCookieConsent();
});
